module.exports = __webpack_public_path__ + "img/Secret-Box.89f339cd.png";